import { apiRequest } from '../api/apiClient';

const SESSION_FLAG = 'gadkot_site_session_recorded';

let recordInFlight = null;

function createSessionId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `sess-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

export async function fetchSiteTrafficStats() {
  return apiRequest('/api/v1/site/traffic', { method: 'GET' });
}

export async function recordSiteSessionIfNeeded() {
  if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SESSION_FLAG)) {
    return fetchSiteTrafficStats();
  }

  if (recordInFlight) {
    return recordInFlight;
  }

  recordInFlight = (async () => {
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SESSION_FLAG)) {
      return fetchSiteTrafficStats();
    }

    const sessionId = createSessionId();
    try {
      const data = await apiRequest('/api/v1/site/traffic/sessions', {
        method: 'POST',
        body: { sessionId },
      });
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem(SESSION_FLAG, '1');
      }
      return data;
    } catch {
      return fetchSiteTrafficStats().catch(() => null);
    } finally {
      recordInFlight = null;
    }
  })();

  return recordInFlight;
}

export function formatVisitCount(value, locale = 'en') {
  const count = Number(value);
  if (!Number.isFinite(count) || count < 0) return '—';
  const tag = locale === 'mr' ? 'mr-IN' : 'en-IN';
  return new Intl.NumberFormat(tag).format(count);
}
